<template>
  <MyModal
    :title="getTitle"
    height="auto"
    v-if="isShow"
    @closeClick="handleCloseModalClick"
  >
    <div class="my-content">
      <template v-if="showDialog">
        <div class="dialog-content resource-import-dialog">
          <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="资源文件" v-if="!isEdit">
              <el-upload
                class="upload-demo"
                ref="upload"
                :with-credentials="true"
                :auto-upload="false"
                :action="action"
                :data="extraData"
                :on-change="handleChange"
                :on-success="uploadSuccessCb"
                :on-error="uploadErrorCb"
                :file-list="fileList"
                :show-file-list="false"
                accept=".wrg"
              >
                <div class="click-area">
                  <div class="file-name">{{ uploadFileName }}</div>
                  <!-- <el-button type="text">上传</el-button> -->
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="资源文件坐标系">
              <StandInput
                v-model="form.sourceId"
                myType="select"
                :selectOptions="coordinateList"
                @change="
                  val => {
                    handleCoordinateChange(val, 'coord');
                  }
                "
              ></StandInput>
            </el-form-item>
            <el-form-item label="度带宽度">
              <StandInput
                v-model="form.zoneWideId"
                myType="select"
                :selectOptions="zoneWideList"
                @change="
                  val => {
                    handleCoordinateChange(val, 'wide');
                  }
                "
              ></StandInput>
            </el-form-item>
            <el-form-item label="度带号">
              <StandInput
                v-model="form.zoneNoId"
                myType="select"
                :selectOptions="zoneNoList"
                @change="
                  val => {
                    handleCoordinateChange(val, 'zone');
                  }
                "
              ></StandInput>
            </el-form-item>
            <el-form-item label="中央子午线">
              <div style="padding-left:10px">
                {{ form.centralMeridian | transeCentral }}
              </div>
            </el-form-item>
            <el-form-item label="转换参数△X">
              <StandInput v-model="form.conversionX" onlyNumber></StandInput>
            </el-form-item>
            <el-form-item label="转换参数△Y">
              <StandInput v-model="form.conversionY" onlyNumber></StandInput>
            </el-form-item>
            <el-form-item label="转换参数△Z">
              <StandInput v-model="form.conversionZ" onlyNumber></StandInput>
            </el-form-item>
          </el-form>
          <div class="text-right">
            <ct-button type="primary" :btnClick="hanldeImport">
              {{ isEdit ? '修改' : '上传' }}
            </ct-button>
          </div>
        </div>
      </template>

      <template v-else>
        <div v-if="!hasTupu" class="top-area">
          <el-button icon="el-icon-plus" @click="showDialog = !showDialog"
            >添加图谱</el-button
          >
        </div>
        <div v-else class="another-top-area">
          <div class="imgs">
            <div
              :class="[
                'btn-item',
                {
                  'is-active': activeTupu === 0
                }
              ]"
              @click="setActive(0)"
            >
              风速
            </div>
            <div
              :class="[
                'btn-item',
                {
                  'is-active': activeTupu === 1
                }
              ]"
              @click="setActive(1)"
            >
              风功率
            </div>

            <!-- <el-tooltip effect="dark" content="风速" placement="top-start">
              <div
                @click="setActive(0)"
                :class="[
                  'element-box',
                  {
                    'is-active': activeTupu === 0
                  }
                ]"
              >
                <img :src="fadianSrc" alt="风速" />
              </div>
            </el-tooltip>

            <el-tooltip effect="dark" content="风功率" placement="top-start">
              <div
                @click="setActive(1)"
                :class="[
                  'element-box',
                  {
                    'is-active': activeTupu === 1
                  }
                ]"
              >
                <img :src="gonglvSrc" alt="风功率" />
              </div>
            </el-tooltip> -->
          </div>
          <div class="tupu-box" v-if="currentResCtx.values.length > 0">
            <color-simple
              type="horizontal"
              :colors="colors"
              :values="currentResCtx.values"
              :unit="currentResCtx.unit"
              width="100%"
            ></color-simple>
          </div>
          <div class="btn-area">
            <el-button type="text" @click="handleChangeRes">修改</el-button>
            <el-button type="text" @click="handleDelRes">删除</el-button>
          </div>
        </div>
      </template>
      <!-- <MyModal
        className="my-modal"
        :title=""
        width="370px"
        height="auto"
        top="15vh"
        @closeClick="handleCloseDialog"
      >
      </MyModal> -->
    </div>
  </MyModal>
</template>

<script>
import gonglvSrc from '../images/gonglv.svg';
import fadianSrc from '../images/fadian.svg';
import loadingMask from '@/components/loading-mask';
import StandInput from '../stand-input';
import { getToken } from '@/utils';
import MyModal from '../modal';
import { mapGetters } from 'vuex';
import { FLOW_COLORS } from '@/utils/constants';
import { toFixed } from '../utils';
export default {
  components: {
    MyModal,
    StandInput
  },
  data() {
    return {
      colors: FLOW_COLORS,
      isEdit: false,
      gonglvSrc,
      fadianSrc,
      hasTupu: false,
      isShow: true,
      showDialog: false,
      form: {
        centralMeridian: '',
        conversionX: '',
        conversionY: '',
        conversionZ: '',
        zoneNo: '',
        zoneNoId: '',
        zoneWideId: '',
        sourceId: ''
      },
      action: `${process.env.VUE_APP_API_HOST}/windfarm/windfarm/analysisWrgFile`,
      fileList: [],
      uploadFileName: '',
      coordinateList: [],
      zoneWideList: [],
      zoneNoList: [],
      switch: null,
      repeatForm: {}
      // rawForm: {
      //   centralMeridian: '',
      //   conversionX: '',
      //   conversionY: '',
      //   conversionZ: '',
      //   sourceCode: '',
      //   sourceId: null,
      //   sourceName: '',
      //   userId: null,
      //   windfarmId: null,
      //   wrgId: null,
      //   zoneNo: '',
      //   zoneNoId: null,
      //   zoneWide: '',
      //   zoneWideId: null
      // }
    };
  },
  filters: {
    transeCentral(val) {
      if (!val) return '';

      let rel = val.substr(0, val.length - 1);

      if (val[val.length - 1] === 'w') {
        rel = -rel;
      }

      return rel;
    }
  },
  watch: {
    isShow(val) {
      if (val) {
        this.getCoordinateReferenceList(true);
      }
    },
    wrgInfoForm: {
      handler() {
        this.getWrgInfo();
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapGetters('WindFarm', ['wrgInfoForm', 'activeTupu', 'resourceTupuObj']),
    sourceCode() {
      const i = this.coordinateList.find(
        item => item.sourceId === this.form.sourceId
      );

      return i?.sourceCode || '';
    },
    getTitle() {
      if (this.showDialog) {
        return this.isEdit ? '修改信息' : '上传资源';
      }
      return '资源';
    },
    extraData() {
      const zoneNo = this.zoneNoList.find(
        item => item.zoneNoId === this.form.zoneNoId
      )?.zoneNo;

      function transeCentral(val) {
        if (!val) return '';

        let rel = val.substr(0, val.length - 1);

        if (val[val.length - 1] === 'w') {
          rel = -rel;
        }

        return rel;
      }

      return {
        apiKey: getToken(),
        ...this.form,
        centralMeridian: transeCentral(this.form.centralMeridian),
        zoneNo,
        sourceCode: this.sourceCode,
        windfarmId: this.$route.query.windfarmId
      };
    },
    currentResCtx() {
      if (this.activeTupu == -1) return { values: [] };

      const { max, min } = this.resourceTupuObj;

      const name = this.activeTupu == 0 ? 'wspd' : 'wpd';

      const unit = (max - min) / 10;
      const newArr = new Array(11).fill('');

      const dyValues = newArr.map((i, index) => {
        let fixUnit = 0;
        if (name === 'wspd') {
          fixUnit = 1;
        }

        return toFixed(min + unit * index, fixUnit);
      });

      return {
        wspd: {
          unit: 'm/s',
          values: dyValues
        },
        wpd: {
          unit: 'W/㎡',
          values: dyValues
        }
      }[name];
    }
  },
  created() {
    // this.query();
    // this.getWrgInfo();
    this.getCoordinateReferenceList(true);
  },
  methods: {
    handleChangeRes() {
      this.isEdit = true;
      this.showDialog = true;

      this.repeatForm = {
        ...this.form
      };
    },
    setActive(number) {
      if (this.activeTupu === number) {
        this.$store.commit('WindFarm/SET_TUPUOBJ', {});
        this.$store.commit('WindFarm/SET_ACTIVE_TUPU_INDEX', -1);

        return;
      }

      this.$store.commit('WindFarm/SET_ACTIVE_TUPU_INDEX', number);
      this.queryTupu(number === 0 ? 'wspd' : 'wpd');
    },
    queryTupu(elementCode) {
      this.$fetch('/windfarm/windfarm/createWrgPic', {
        showError: true,
        params: {
          elementCode: elementCode,
          windfarmId: this.$route.query.windfarmId
        }
      }).then(res => {
        const { data = {} } = res;
        this.$store.commit('WindFarm/SET_TUPUOBJ', data);
      });
    },
    getWrgInfo() {
      const { hasTupu, ...others } = this.wrgInfoForm;
      this.hasTupu = hasTupu;
      this.form = { ...others };

      const i =
        this.zoneNoList.find(item => item.value == this.form.zoneNoId) || {};
      this.form.centralMeridian = i?.centralMeridian;
    },
    handleCoordinateChange(val, type) {
      if (type === 'coord') {
        this.form.zoneWideId = '';
        this.form.zoneNoId = '';
        this.getzoneWide(val);
      }

      if (type === 'wide') {
        this.form.zoneNoId = '';
        this.getzoneNoList(val);
      }

      if (type === 'zone') {
        const i = this.zoneNoList.find(item => item.value === val) || '';

        this.form.centralMeridian = i.centralMeridian;
      }
    },
    getzoneWide(id, init) {
      this.$fetch('/windfarm/windfarm/getzoneWide', {
        showError: true,
        params: {
          sourceId: id
        }
      }).then(res => {
        const { data = {} } = res || {};

        const { data: _data = [] } = data;
        this.zoneWideList = _data.map(item => ({
          label: item.zoneWide,
          value: item.zoneWideId,
          ...item
        }));

        if (init) {
          this.form.zoneWideId = this.wrgInfoForm.zoneWideId;
        } else {
          this.form.zoneWideId = this.zoneWideList[0]?.value;
        }

        if (init) {
          this.getzoneNoList(this.form.zoneWideId, true);
        } else {
          this.getzoneNoList(this.form.zoneWideId, false);
        }
      });
    },
    getzoneNoList(id, init) {
      this.$fetch('/windfarm/windfarm/getzoneNoList', {
        showError: true,
        params: {
          zoneWideId: id
        }
      }).then(res => {
        const { data = {} } = res || {};

        const { data: _data = [] } = data;
        this.zoneNoList = _data.map(item => ({
          label: item.zoneNo,
          value: item.zoneNoId,
          ...item
        }));

        if (init) {
          this.form.zoneNoId = this.wrgInfoForm.zoneNoId;
        } else {
          this.form.zoneNoId = this.zoneNoList[0]?.value;
        }

        const i = this.zoneNoList.find(
          item => item.value === this.form.zoneNoId
        );
        this.form.centralMeridian = i.centralMeridian;
      });
    },
    getCoordinateReferenceList(init) {
      this.$fetch('/windfarm/windfarm/getCoordinateReferenceList', {
        showError: true
      }).then(res => {
        const { data } = res;
        const { data: _data = [] } = data;

        this.coordinateList = _data.map(item => ({
          label: item.sourceName,
          value: item.sourceId,
          ...item
        }));

        if (init) {
          this.form.sourceId = this.wrgInfoForm.sourceId;
        } else {
          this.form.sourceId = this.coordinateList[0]?.value;
        }

        if (init) {
          this.getzoneWide(this.form.sourceId, true);
        } else {
          this.getzoneWide(this.form.sourceId);
        }
      });
    },
    query() {
      this.$fetch('/windfarm/windfarm/getWrgInfoList', {
        showLoading: true,
        showError: true,
        params: {
          windfarmId: this.$route.query.windfarmId
        }
      }).then(res => {
        const { data } = res;
        const { wrgInfoList = [] } = data;

        this.hasTupu = wrgInfoList.length > 0;
      });
    },
    handleCloseModalClick() {
      if (this.showDialog) {
        if (this.isEdit) {
          this.form = {
            ...this.repeatForm
          };
          this.showDialog = false;
          this.isEdit = false;
        } else {
          this.showDialog = false;
          this.uploadFileName = '';
          this.fileList = [];
        }
      } else {
        this.$bus.$emit('farmClick', 0);
      }
    },
    handleChange(file, fileList) {
      if (file.response) {
        this.file = null;
        this.uploadFileName = '';
        this.fileList = [];
        return;
      }

      if (!fileList.length) {
        this.file = null;
        this.uploadFileName = '';
      } else {
        this.file = file;
        this.uploadFileName = file?.name;
        this.fileList = [file];
      }
    },
    uploadSuccessCb(res) {
      this.switch.close();
      const { code, message } = res;
      if (code === 0) {
        this.showDialog = false;
        this.$refs.upload.clearFiles();
        this.$message({
          message: message,
          type: 'success'
        });
        this.$store.dispatch('WindFarm/getWrgInfo', {
          params: {
            windfarmId: this.$route.query.windfarmId
          },
          activeTupu: this.activeTupu
        });
      } else {
        this.$message({
          message: message,
          type: 'error'
        });
      }
    },
    uploadErrorCb(res) {
      this.switch.close();
      this.fileList = [];
      this.uploadFileName = '';
      const { message } = res;
      this.$message({
        message: message,
        type: 'error'
      });
    },
    handleCloseDialog() {},
    handleDelRes() {
      this.$confirm('是否确认删除', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.$postForm('/windfarm/windfarm/deleteWrgInfo', {
          data: {
            windfarmId: this.$route.query.windfarmId
          },
          showSuccess: true,
          showError: true,
          showLoading: true
        }).then(() => {
          this.$store.dispatch('WindFarm/getWrgInfo', {
            params: {
              windfarmId: this.$route.query.windfarmId
            },
            activeTupu: this.activeTupu
          });
        });
      });
    },
    hanldeImport() {
      if (this.isEdit) {
        this.$postForm('/windfarm/windfarm/updateWrgInfo', {
          data: {
            ...this.form,
            sourceCode: this.sourceCode,
            centralMeridian: transeCentral(this.form.centralMeridian),
            windfarmId: this.$route.query.windfarmId
          },
          showLoading: true,
          showError: true,
          showSuccess: true
        }).then(() => {
          this.isEdit = false;
          this.showDialog = false;
          this.$store.dispatch('WindFarm/getWrgInfo', {
            params: {
              windfarmId: this.$route.query.windfarmId
            },
            activeTupu: this.activeTupu
          });
        });
      } else {
        if (this.fileList.length == 0) {
          this.$message({
            message: '请上传资源文件',
            type: 'warn'
          });
          return;
        }
        this.switch = loadingMask({
          mask: true
        });
        this.$refs.upload.submit();
      }

      function transeCentral(val) {
        if (!val) return '';

        let rel = val.substr(0, val.length - 1);

        if (val[val.length - 1] === 'w') {
          rel = -rel;
        }

        return rel;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.tupu-box {
  border-radius: 8px;
  padding: 10px;
  background-color: #fff;
  margin-top: 10px;
}
.upload-demo {
  height: 28px;

  .click-area {
    .file-name {
      height: 30px;
      width: 200px;
      padding-left: 10px;
      text-align: left;
      margin-right: 20px;
      border: 2px solid #d9e6f3;
      background-color: #fff;
      border-radius: 7px;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
    display: flex;
    justify-content: space-between;
  }
}

.top-area {
  padding: 5px 0;
}
.another-top-area {
  padding: 5px 0;
  .btn-area {
    text-align: right;
    margin-top: 10px;
  }
  .imgs {
    display: flex;
  }
  .element-box {
    flex: 1;
    height: 80px;
    border-radius: 5px;
    border: 2px solid transparent;

    display: flex;
    background-color: #fff;
    cursor: pointer;
    padding: 10px;

    &.is-active {
      border: 2px solid @blue;
    }

    img {
      height: 100%;
      width: 100%;
    }

    &:first-child {
      margin-right: 10px;
    }
  }
}
.content-table {
  margin-top: 5px;
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 10px 0px;
  border-radius: 3px;
  .icon {
    cursor: pointer;
    width: 30px;
    height: 40px;

    display: flex;
    align-items: center;
    justify-content: center;
  }
  .name {
    height: 40px;
    width: 90px;
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: center;
    margin-left: 10px;
  }

  .edit-btn {
    display: flex;
    justify-content: center;
    flex: 1;
    margin-left: 5px;
  }
}

.my-modal {
  top: 0px;
  left: 0px;
}

.my-content {
  padding: 5px 10px 10px 10px;

  .btn-item {
    display: inline-block;
    padding: 5px;
    line-height: 20px;
    width: 70px;
    border: 2px solid #a8cae9;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    background-color: #d9e6f3;

    &:not(:last-child) {
      margin-right: 5px;
    }

    &.is-active {
      background-color: #0159ac;
      color: #fff;
    }
  }
}

.dialog-content {
  padding: 20px 20px 10px 10px;
}
</style>

<style lang="less">
.resource-import-dialog {
  .stand-select-core {
    top: -1px;
  }
}
</style>
